document.addEventListener('DOMContentLoaded', function() {
  const slider = document.querySelector('.slider-container');
  const prevBtn = document.querySelector('.slider-arrow.prev');
  const nextBtn = document.querySelector('.slider-arrow.next');
  const cards = document.querySelectorAll('.review-card');
  const cardWidth = cards[0].offsetWidth + 24; // card width + gap
  let currentIndex = 0;
  const cardsPerView = window.innerWidth > 1024 ? 3 : window.innerWidth > 767 ? 2 : 1;
  const maxIndex = cards.length - cardsPerView;

  function updateSlider() {
    const offset = -currentIndex * cardWidth;
    slider.style.transform = `translateX(${offset}px)`;
    
    prevBtn.classList.toggle("disabled", currentIndex === 0);
    nextBtn.classList.toggle("disabled", currentIndex >= maxIndex);
  }

  function handlePrevClick() {
    if (currentIndex > 0) {
      currentIndex--;
      updateSlider();
    }
  }

  function handleNextClick() {
    if (currentIndex < maxIndex) {
      currentIndex++;
      updateSlider();
    }
  }

  prevBtn.addEventListener('click', handlePrevClick);
  nextBtn.addEventListener('click', handleNextClick);

  // Update on window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      const newCardsPerView = window.innerWidth > 1024 ? 3 : window.innerWidth > 767 ? 2 : 1;
      if (newCardsPerView !== cardsPerView) {
        currentIndex = 0;
        updateSlider();
      }
    }, 250);
  });

  // Initial setup
  updateSlider();
});